<template>
	<AssemblyLayout :assembly="assembly" :subtitle="trans('assemblies.elections.college-zone-representatives.title')">
		<Empty v-if="elections.length === 0"/>
		<CardGrid v-else>
			<Card v-for="election in elections" :key="`college-zone-representative-election-${election.id}`" :title="trans(`colleges.${election.college_zone}`)">
				<template #badges>
					<Badge v-if="election.open" :color="Color.Green" active>{{ trans('general.open') }}</Badge>
					<Badge v-else :color="Color.Red">{{ trans('general.closed') }}</Badge>
				</template>
				<LabeledObject>
					<template #label>{{ trans('assemblies.seats') }}</template>
					<p>{{ election.limit }}</p>
				</LabeledObject>
				<template #footer>
					<Link :as="SecondaryButton" :color="Color.Blue" :href="route('association.assemblies.elections.college-zone-representatives.show', {assembly: assembly.id, election: election.id})">
						<i class="fa-solid fa-edit mr-2"/>
						{{ trans('general.edit') }}
					</Link>
				</template>
			</Card>
		</CardGrid>
	</AssemblyLayout>
</template>
<script setup lang="ts">
import {route} from 'ziggy-js'
import {ref, type Ref} from 'vue'
import {Link} from '@inertiajs/vue3'
import {trans} from 'laravel-vue-i18n'
import {Color} from '@/Types/Enums/Color'
import Empty from '@/Components/UI/Empty.vue'
import Card from '@/Components/UI/Cards/Card.vue'
import Badge from '@/Components/UI/Badges/Badge.vue'
import CardGrid from '@/Components/UI/Cards/CardGrid.vue'
import AssemblyLayout from '@/Layouts/AssemblyLayout.vue'
import LabeledObject from '@/Components/UI/LabeledObject.vue'
import {type Assembly} from '@/Types/Association/Assemblies/Assembly'
import SecondaryButton from '@/Components/UI/Buttons/SecondaryButton.vue'
import {type CollegeZoneRepresentativeElection} from '@/Types/Elections/Assemblies/CollegeZoneRepresentativeElection'

const props = defineProps<{
	assembly:Assembly,
	selectedTab:string,
	elections:Array<CollegeZoneRepresentativeElection>,
}>()

const assembly:Ref<Assembly> = ref(props.assembly)
const elections:Ref<Array<CollegeZoneRepresentativeElection>> = ref(props.elections)
</script>